import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';
import { formatPrice } from '../../utils/currency';
import { fromPrice, hasRange, productPath } from '../../utils/products';
import type { Product } from '../../types/product';
import { Stars } from './Stars';
const badgeLabel: Record<string, string> = {
  bestseller: 'Bestseller',
  nieuw: 'Nieuw',
  cadeau: 'Cadeau'
};
export function ProductCard({
  product
}: {
  product: Product;
}) {
  const {
    add
  } = useCart();
  const first = product.variants[0];
  const badge = product.badges[0];
  const to = productPath(product);
  return <article className="group relative flex h-full flex-col" data-id="element-491" data-mp="271gazvmm6xxz">
      <Link to={to} className="relative block overflow-hidden bg-surface" data-id="element-492" data-mp="223o7038p3ldf">
        <img src={product.image} alt={`${product.name} – ${product.subtitle}`} loading="lazy" className="aspect-square w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-493" data-mp="221bptsarhf1f" />
        {product.gallery[1] && <img src={product.gallery[1]} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-300 ease-out group-hover:opacity-100" data-id="element-494" data-mp="3gpvshsoee60j" />}
        {badge && <span className="absolute left-0 top-3 z-10 bg-ink px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-white" data-id="element-495" data-mp="3vifrqi8fftcp">
            {badgeLabel[badge]}
          </span>}
      </Link>
      <div className="flex flex-1 flex-col pt-4" data-id="element-496" data-mp="8ac5hbebljtx">
        <h3 className="text-sm font-semibold uppercase tracking-[0.1em] text-ink" data-id="element-497" data-mp="daqa0jgpqbn7">
          <Link to={to} className="hover:underline hover:underline-offset-4" data-id="element-498" data-mp="ia2wv47l3ips">{product.name}</Link>
        </h3>
        <p className="mt-1 text-sm font-light text-muted" data-id="element-499" data-mp="2f364nd49ofxl">{product.subtitle}</p>
        <div className="mt-2" data-id="element-500" data-mp="2k1pvnrxpwhwt">
          <Stars rating={product.rating} reviews={product.reviews} data-id="element-501" data-mp="2k0y02h44ek6j" />
        </div>
        <p className="mt-auto pt-3 text-base font-semibold text-ink" data-id="element-502" data-mp="2c0i4prt41ter">
          {hasRange(product) && <span className="mr-1 text-sm font-normal text-muted" data-id="element-503" data-mp="2726wfligrqyn">vanaf</span>}
          {formatPrice(fromPrice(product))}
          {first.compareAt && <span className="ml-2 text-sm font-normal text-muted line-through" data-id="element-504" data-mp="2lzzcqfvu4jdw">{formatPrice(first.compareAt)}</span>}
        </p>
        <button type="button" onClick={() => add(product.slug, first.id)} className="mt-3 h-11 w-full whitespace-nowrap bg-ink text-xs font-semibold uppercase tracking-[0.14em] text-white transition-colors duration-150 hover:bg-pink" aria-label={`${product.name} (${first.label}) toevoegen aan winkelwagen`} data-id="element-505" data-mp="2h27ktlv6wx9p">
          In winkelwagen
        </button>
      </div>
    </article>;
}